var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNetwork = function SvgNetwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M14.75 9a4.68 4.68 0 0 1 3.75 1.875M1 10.875A4.68 4.68 0 0 1 4.75 9M9.75 14a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M5.375 16.5a5.077 5.077 0 0 1 8.75 0M12.328 5.875A2.5 2.5 0 1 1 14.75 9M4.75 9a2.5 2.5 0 1 1 2.422-3.125"
  })));
};
export default SvgNetwork;